import { createAction } from "@reduxjs/toolkit";

export const FETCH_STUDENT_CLASS_MODULE = 'FETCH_STUDENT_CLASS_MODULE';
export const FETCH_SUBMODULE_TREE_STUDENT = 'FETCH_SUBMODULE_TREE_STUDENT';
export const FETCH_SUB_MODULE_DETAIL_STUDENT_PRACTICE = 'FETCH_SUB_MODULE_DETAIL_STUDENT_PRACTICE';
export const FETCH_PDF_LIST = 'FETCH_PDF_LIST';

export const STUDENT_ANSWER_QUESTION = 'STUDENT_ANSWER_QUESTION';
export const STUDENT_END_SUB_MODULE_SESSION = 'STUDENT_END_SUB_MODULE_SESSION';
export const STUDENT_WRONG_QUESTIONS = 'STUDENT_WRONG_QUESTIONS';
export const PRACTICE_ENROLL_SINGLE_ITEM = 'PRACTICE_ENROLL_SINGLE_ITEM';
export const EMG_INSERT_RESULT_DATA = 'EMG_INSERT_RESULT_DATA';

type practiceEnrollType = {
  username: string | null;
  course_id: string | null;
  status: string | null;
  is_check: boolean | null;
}

export type practiceEnrollmentUpdateType = {
  enrollments: practiceEnrollType[];
}

export type EmgResultScore = {
  min?: number;
  max?: number;
  raw?: number;
  scaled?: number;
};

export type EmgResultPayload = {
  score?: EmgResultScore;
  success?: boolean | string | number;
  duration?: string;
  response?: string;
  [key: string]: any;
};

export type EmgInsertResultDataBody = {
  session_id: number;
  type: 'practice' | 'exam' | 'learning' | string;
  /** Lazy practice/exam: block path identifying the question template */
  block_id?: string | null;
  data: {
    result?: EmgResultPayload;
    interact_data?: Record<string, any>;
    source?: string;
    url?: string;
    block_id?: string;
    [key: string]: any;
  };
};

/** Correlates edx_insert_result_data fallback with a cache entry (H5P answer sync). */
export type EmgInsertResultFallbackMeta = {
  cacheKey: string;
  sessionKey: string;
  pageNumber: number;
  submitSeq: number;
};

export type EmgInsertResultOutcome = {
  id: number;
  meta: EmgInsertResultFallbackMeta;
  success: boolean;
  message?: string;
};

export const fetchStudentClassModule = createAction(FETCH_STUDENT_CLASS_MODULE, (type?: number) => ({
  payload: { type }
}))
export const fetchSubModuleTree = createAction(FETCH_SUBMODULE_TREE_STUDENT, (moduleId: string, classId: string, practice_type?: number) => ({
  payload: { moduleId, classId, practice_type }
}))

export const fetchSubModuleDetail = createAction(FETCH_SUB_MODULE_DETAIL_STUDENT_PRACTICE, ((subModuleId: string, classId: string) => ({
  payload: {
    subModuleId,
    classId
  }
})))
export const fetchPdfList = createAction(FETCH_PDF_LIST, ((subModuleId: string, classId: string) => ({
  payload: {
    subModuleId,
    classId
  }
})))
export const studentAnswerQuestion = createAction(STUDENT_ANSWER_QUESTION, ((questionId: string) => ({
  payload: {
    questionId
  }
})))

export const studentEndSubModuleSession = createAction(STUDENT_END_SUB_MODULE_SESSION, ((sessionId: string) => ({
  payload: {
    sessionId
  }
})))

export const fetchStudentWrongQuestions = createAction(STUDENT_WRONG_QUESTIONS, ((sessionId: string) => ({
  payload: {
    sessionId
  }
})))

export const practiceEnrollSingleItem = createAction<any>(PRACTICE_ENROLL_SINGLE_ITEM, (data: practiceEnrollmentUpdateType) => ({
  payload: { data: data },
}));

export const emgInsertResultData = createAction(
  EMG_INSERT_RESULT_DATA,
  (payload: { data: EmgInsertResultDataBody; meta: EmgInsertResultFallbackMeta }) => ({
    payload,
  }),
);